import { FC } from 'react'

const Profile: FC = () => {
  return <>Profile</>
}

export default Profile
